import { Controller } from "@hotwired/stimulus"

const locale = document.documentElement.lang || 'en-US';
const timeZoneResolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
const localTimeFormatter = new Intl.DateTimeFormat(locale, {
  timeZone: timeZoneResolved,
  timeZoneName: "short",
  hour: "numeric",
  minute: "2-digit",
  hour12: true
});
const utcTimeFormatter = new Intl.DateTimeFormat(locale, {
  timeZone: "UTC",
  timeZoneName: "short",
  hour: "numeric",
  minute: "2-digit",
  hour12: true
});

// Connects to data-controller="local-time"
//
// Two modes of operation:
// 1. Form input mode: Uses input/hour/minute/display targets with change() action
// 2. Display-only mode: Uses hour/minute values and displays on connect()
//    Example: <span data-controller="local-time" data-local-time-hour-value="14" data-local-time-minute-value="30"></span>
export default class extends Controller {
  static targets = ['hour', 'minute', 'input', 'display'];
  static values = { hour: Number, minute: Number };

  connect() {
    // Display-only mode: if we have hour/minute values but no input target
    if (this.hasHourValue && this.hasMinuteValue && !this.hasInputTarget) {
      this.displayTimeFromValues()
    }
  }

  // Display-only mode: render time from values
  displayTimeFromValues() {
    const datetime = new Date()
    datetime.setUTCHours(this.hourValue, this.minuteValue, 0, 0)

    const localTime = localTimeFormatter.format(datetime)
    const utcTime = utcTimeFormatter.format(datetime)
    this.element.textContent = `${localTime} / ${utcTime}`
  }

  // Form input mode: called when input changes
  change() {
    const datetime = new Date()
    datetime.setUTCHours(...this.inputTarget.value.split(":"))

    const localTime = localTimeFormatter.format(datetime)
    const utcTime = utcTimeFormatter.format(datetime)

    if (this.hasHourTarget) this.hourTarget.value = datetime.getUTCHours();
    if (this.hasMinuteTarget) this.minuteTarget.value = datetime.getUTCMinutes();
    if (this.hasDisplayTarget) this.displayTarget.textContent = `${localTime} / ${utcTime}`;
  }
}
